<template>
  <div class="block">
    <div class="flex items-center justify-center mb-0.5">
      <base-svg-icon class="w-6" :class="iconClass" :path="path" />
    </div>
    <div class="flex items-center justify-center">
      <div class="font-semibold text-xs whitespace-nowrap flex items-center">
        <div>{{ text }}</div>
        <template v-if="open">
          <base-svg-icon class="w-4 ml-0.5" :path="mdiOpenInNew" />
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mdiOpenInNew } from '@mdi/js'

import BaseSvgIcon from '@/components/BaseSvgIcon.vue'

export default defineComponent({
  components: { BaseSvgIcon },
  props: {
    path: {
      type: String,
      'default': () => (''),
    },
    text: {
      type: String,
      'default': () => (''),
    },
    iconClass: {
      type: String,
      'default': () => (''),
    },
    open: {
      type: Boolean,
      'default': () => (false),
    }
  },
  setup() {
    return {
      mdiOpenInNew
    }
  },
})
</script>
